import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetTramSeguimientos, TramSeguimientoDto } from '../../shared/interfaces/database/tramite';


@Injectable({
  providedIn: 'root'
})
export class TramSeguimientoService {
  private readonly baseUrl = `${environment.apiUrl}/api/tram-seguimiento`;

  constructor(private http: HttpClient) { }

  getTramSeguimientos(tramActividadId: number): Observable<IGetTramSeguimientos[]> {
    return this.http.get<IGetTramSeguimientos[]>(`${this.baseUrl}/${tramActividadId}`);
  }

  createSeguimiento(tramActividadId: number, request: TramSeguimientoDto): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));

    return this.http.post(`${this.baseUrl}/${tramActividadId}`, formData, { responseType: 'text' });
}
}
